import { RefObject, useEffect } from 'react';

type ConditionFunction = () => boolean;

export const useGainFocus = <El extends HTMLElement>(
    who: RefObject<El> | El | null | undefined,
    when: boolean | number | string | ConditionFunction,
) => {
    useEffect(() => {
        if ((typeof when === 'function' && when() === false) || !who) {
            return;
        }
        if (who instanceof HTMLElement) {
            who?.focus({ preventScroll: true });
            who?.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        } else {
            who?.current?.focus({ preventScroll: true });
            who?.current?.scrollIntoView({ behavior: 'instant', block: 'nearest' });
        }
    }, [when, who]);
};
